import { useSelector } from 'react-redux'

import {
  selectSIM,
  selectSIMFieldSources,
  selectSIMStatus,
  selectSIMWithSources
} from 'redux/selectors/SIM'

/**
 * Hook for the standard information model (SIM) structure
 */
export const useSIM = () => {
  return useSelector(selectSIM)
}

/**
 * Hook for the SIM fetch status
 */
export const useSIMStatus = () => {
  return useSelector(selectSIMStatus)
}

/**
 * Hook for SIM tables with resolved source names from SimTableStore
 */
export const useSIMWithSources = () => {
  return useSelector(selectSIMWithSources)
}

/**
 * Hook for the resolved source tables and source columns per SIM table
 */
export const useSIMFieldSources = () => {
  return useSelector(selectSIMFieldSources)
}
